import React from 'react';
import { Box, FormControl, Typography } from '@mui/material';
import CustomSelect from 'app/components/CustomSelect';
import CustomInput from 'app/components/CustomInput';
import AlertIcon from 'app/components/Icons/AlertIcon';
import { grey10 } from 'app/components/ThemeProvider/colors';
import FieldError from 'app/components/FieldError';

const options = [
  { value: 'Alan hesab1', label: 'Alan hesab1' },
  { value: 'Alan hesab2', label: 'Alan hesab2' },
  { value: 'Alan hesab3', label: 'Alan hesab3' },
  { value: 'Alan hesab4', label: 'Alan hesab4' },
];

interface Props {
  value: any;
  accountOptions?: any;
  selectedFromAccount?: any;
  onChangeFromAccount?: (value: any) => void;
  control?: any;
  register?: any;
  errors?: any;
  onChangeCommission?: any;
  selectedCommission?: any;
  dataForm?: any;
  onChangeAmount?: any;
  amount?: any;
  commissionOption?: any;
}

const PaymentDetailsCountry = (props: Props) => {
  const {
    value,
    errors,
    register,
    control,
    accountOptions,
    selectedFromAccount,
    onChangeFromAccount,
    selectedCommission,
    onChangeCommission,
    dataForm,
    onChangeAmount,
    amount,
    commissionOption,
  } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomSelect
            title={'Məxaric hesabı'}
            placeholder={'Məxaric hesabı'}
            options={accountOptions}
            rest={{ ...register('fromAccount') }}
            control={control}
            optionValue={true}
            valueOption={'value'}
            optionLabel={true}
            labelOption={'label'}
            value={selectedFromAccount}
            onChange={onChangeFromAccount}
            isValid={errors?.fromAccount !== undefined}
          />
          <FieldError error={errors.fromAccount} />
        </FormControl>
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomSelect
            title={'Komissiyanın məxaric hesabı'}
            placeholder={'Komissiyanın məxaric hesabı'}
            options={commissionOption}
            rest={{ ...register('commission') }}
            control={control}
            optionValue={true}
            valueOption={'value'}
            optionLabel={true}
            labelOption={'label'}
            value={selectedCommission}
            onChange={onChangeCommission}
            isValid={errors?.commission !== undefined}
          />
          <FieldError error={errors.commission} />
        </FormControl>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '28px',
          width: '100%',

          '@media screen and (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
          },
        }}
      >
        <FormControl
          sx={{
            width: 'fit-content',
            '@media screen and (max-width: 1100px)': {
              width: 'calc((100% - 28px) / 2)',
            },

            '@media screen and (max-width: 768px)': {
              width: '100%',
            },
          }}
        >
          <CustomInput
            title={'Məbləğ'}
            placeholder={'Məbləğ'}
            rest={{ ...register('amount') }}
            isValid={errors?.amount !== undefined || dataForm?.error?.fields.amount !== undefined}
            handleChange={onChangeAmount}
            value={amount}
          />
          <FieldError
            error={
              errors.amount
                ? errors.amount
                : dataForm?.error?.fields.amount && { message: dataForm?.error?.fields.amount }
            }
          />
        </FormControl>
      </Box>
      {value?.value === 'XOHKS' && (
        <Box
          sx={{
            background: grey10,
            borderRadius: '8px',
            width: '668px',
            height: '52px',
            display: 'flex',
            gap: '12px',
            p: '15px 16px',
            mt: '8px',
          }}
        >
          <AlertIcon color={'warning'} />
          <Typography sx={{ fontSize: '15px' }}>
            Məbləği 40 000 AZN və daha yuxarı olan ödənişlər təcili ödəmə sistemi ilə keçirilir
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default PaymentDetailsCountry;
